export async function copyHtmlAndText(html, text) {
  const clipboardItem = new ClipboardItem({
    "text/html": new Blob([ html ], { type: "text/html" }),
    "text/plain": new Blob([ text ], { type: "text/plain" })
  })
  await navigator.clipboard.write([ clipboardItem ])
}

export async function copyText(text) {
  const clipboardItem = new ClipboardItem({
    "text/plain": new Blob([ text ], { type: "text/plain" })
  })
  await navigator.clipboard.write([ clipboardItem ])
}
